export const comments_5618854 = {"data":{"data":[],"links":{}}}